import { useQuery } from 'react-query';

import { TrapType } from 'components/AnalyticsPage/TrapType';
import { getAnalyticsHeatMapChart } from 'api/analitics/MCTCharts/6_getAnalyticsHeatMapChart';

export const useGetAnalyticsHeatMapChartData = (
  slug: string,
  type: TrapType,
  start_datetime: string,
  end_datetime: string,
  enabled?: { enabled: boolean },
) => {
  const { data, refetch, isLoading, isFetching } = useQuery(
    ['AnalyticsHeatMapChartData', slug, type],
    () => getAnalyticsHeatMapChart(slug, type, start_datetime, end_datetime),
    {
      refetchOnWindowFocus: false,
      enabled: enabled?.enabled ?? true,
    },
  );

  return { data, refetch, isLoading, isFetching };
};

export default useGetAnalyticsHeatMapChartData;
